import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export function SaathiToggleCard() {
  const [enabled, setEnabled] = useState<boolean>(() => {
    try {
      const v = localStorage.getItem("saathi.enabled");
      return v === null ? true : v === "true";
    } catch {
      return true;
    }
  });
  const toggle = (v: boolean) => {
    setEnabled(v);
    try {
      localStorage.setItem("saathi.enabled", String(v));
    } catch {
      // noop
    }
    window.dispatchEvent(new CustomEvent("saathi-enabled-change", { detail: v }));
  };
  return (
    <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
      <div className="p-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div
            className="relative w-10 h-10 rounded-xl flex items-center justify-center overflow-hidden"
            style={{
              background:
                "radial-gradient(circle at 30% 25%, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0) 40%), linear-gradient(135deg, #8B1A1A 0%, #631212 100%)",
            }}
          >
            <Sparkles className="h-5 w-5 text-white" strokeWidth={2.25} />
          </div>
          <div>
            <p className="font-bold text-sm text-slate-900 dark:text-white">Saathi AI</p>
            <p className="text-xs text-slate-500 font-medium">Floating shop assistant</p>
          </div>
        </div>
        <Switch checked={enabled} onCheckedChange={toggle} />
      </div>
    </div>
  );
}
